import React from 'react';
import Locale from '../domain/Locale';
import get_bundle from '../domain/get_bundle';
import shuffle from '../util/shuffle';
import cx from 'classnames';
import MarkdownComponent from './MarkdownComponent';
import { props } from 'tcomb-react';

@props({
  locale: Locale
})
export default class Tips extends React.Component {

  getTip() {
    const bundle = get_bundle(this.props.locale).product;
    return shuffle(bundle.tips.slides).map(function(tip, i) {
      const classes = cx({
        'tip': true,
        'large-show': (i === 0),
        'large-hide': (i !== 0)
      });

      return (
        <div key={i} className={classes}>
          <MarkdownComponent>
            {tip}
          </MarkdownComponent>
        </div>
        );
    });
  }

  showPrev(evt) {
    evt.preventDefault();
    var selected = $('.tip.large-show');
    selected.removeClass('large-show').addClass('large-hide');
    if (selected.prev('.tip').length) {
      selected.prev('.tip').removeClass('large-hide').addClass('large-show');
    }
    else {
      $('.tip').last().removeClass('large-hide').addClass('large-show');
    }
  }

  showNext(evt) {
    evt.preventDefault();
    var selected = $('.tip.large-show');
    selected.removeClass('large-show').addClass('large-hide');
    if (selected.next('.tip').length) {
      selected.next('.tip').removeClass('large-hide').addClass('large-show');
    }
    else {
      $('.tip').first().removeClass('large-hide').addClass('large-show');
    }
  }

  render() {
    const bundle = get_bundle(this.props.locale).product;
    return (
      <div id="tips" className="box help small-hide">
        <div className="title">
          <h2>
            <span>
              {bundle.tips.title}
            </span>
          </h2>
        </div>
        {this.getTip()}
        <div id="tips_nav"><a id="prev_tip" onClick={this.showPrev} href="#">«</a>{bundle.tips.navigator}<a id="next_tip" onClick={this.showNext} href="#">»</a></div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Tips.js
 **/